/**
 * @module lib/VolumeUtils
 */
import { Map } from 'immutable';
import { createSelector } from 'reselect';

import { VolumeKeys } from '../constants/Volume';

/**
 * Retrieves the current global volume value stored in the store on a 100 point
 * scale.
 *
 * @returns {number} The current volume value on a 100 point scale
 */
export const getGlobalVolume = createSelector(
  state => state.volume || Map(),
  volume => volume.get(VolumeKeys.VOLUME),
);

/**
 * Retrieves the current global muted value stored in the store.
 *
 * @returns {boolean} The current muted value
 */
export const getGlobalMuted = createSelector(
  state => state.volume || Map(),
  volume => volume.get(VolumeKeys.MUTED),
);
